<template>
  <FormLabel :ok="ok" :text="text" :error="error" :increased="increased" :class="{ 'disabled': disabled, 'filled': value }">
    <HiddenField :name="name" :value="value" />
    <button ref="input" @keydown.down="$refs.droplist.optionFocus(0)" @click.prevent="$event.target.focus()" :tabindex="(disabled || $store.state.loading) ? -1 : 0" :disabled="disabled || $store.state.loading" class="formfield formfield_select formfield_pointer formfield_witharrow" aria-haspopup="listbox" aria-label="text">{{ value }}
      <svg v-show="!disabled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 9.5L12 14.5L17 9.5" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <DropList @toInput="$refs.input.focus()" :options="options.filter(v => v)" v-model="val" ref="droplist"  />
  </FormLabel>
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import HiddenField from '@/components/HiddenField.vue'
import FormField from '@/mixins/FormField.vue'
import DropList from '@/components/DropList.vue'

export default {
  components: { FormLabel, HiddenField, DropList },
  mixins: [FormField],
  props: {
    disabled: { type: Boolean, required: false },
    increased: { type: Boolean, required: false },
    name: { type: String, required: true },
    value: { type: String, default: '' },
    text: { type: String, required: true },
    options: { type: Array, required: true },
    validation: { type: Function, default: () => '' }
  },
  data: () => ({
    error: ''
  }),
  mounted() {
    if (!this.val)
      this.val = this.options[0]
  },
  computed: {
    ok() {
      if (!this.value) return false
      return true
    },
    val: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
  },
  watch: {
    value(val, old) {
      if (val != old)
        this.$emit('input', val)
      this.error = ''
      if (val)
        this.error = this.validation(val)
    },
  }
}
</script>

<style lang="sass">

</style>